<template>
  <div class="tax-exemption-container">
    <hr class="hr-design">
    <div class="row">
      <span class="tax-logo" />
      <span class="tax-text">
        <span>
          Tax Exempt status:
          <span v-if="!loadingExemptionStatus && exemptionStatus"><small style="margin-left: 1rem">{{
            exemptionStatus.tax_message
          }}</small></span>
          <span
            v-else
            class="loading"
            style="display: inline-block; margin-left: 1rem"
          />
        </span>
        <br>
        <a
          v-if="exemptionStatus && exemptionStatus.tax_exempt === false"
          class="cursorPointer"
          @click="toggleUploadCertificateForm()"
        >View, add, or update certificate</a>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TaxExemptStatusComponent',
  props: ['exemptionStatus', 'loadingExemptionStatus', 'toggleUploadCertificateForm']
}
</script>
<style>
.tax-exemption-container .row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 0;
}
</style>
